module App.Classes {
    export class Address  {
        street: string;
        houseNumber: string;
        postalCode: string;
        city: string;
        remark: string;
        salutation: string;
        firstName: string;
        middleName: string;
        lastName: string;
        phoneNumber: string;
        email: string;
    }
}